import { Controller } from "@hotwired/stimulus"

// Reveals only the field the selected call-to-action type needs. The type sets
// come from Privilege's constants as values, so adding a type stays a one-line
// model change.
export default class extends Controller {
  static targets = ["select", "codeField", "linkField", "poolActions"]
  static values = {
    codeTypes: Array,
    linkTypes: Array,
    poolTypes: Array
  }

  connect() { this.refresh() }

  refresh() {
    const type = this.hasSelectTarget ? this.selectTarget.value : ""

    this.toggle(this.codeFieldTargets, this.codeTypesValue.includes(type))
    this.toggle(this.linkFieldTargets, this.linkTypesValue.includes(type))
    this.toggle(this.poolActionsTargets, this.poolTypesValue.includes(type))
  }

  toggle(elements, visible) {
    elements.forEach((el) => { el.hidden = !visible })
  }
}
